<template lang="pug">
  .header__country(
    :class="{ 'header__country_open': active }"
    v-tap="toggle"
    v-tap-outside="hide"
  )
    .header__country-arrow
    .header__country-link(
      v-for="country in availableSiteVersions"
      :key="country.id"
      v-tap="() => changeCountry(country.code)"
    )
      .header__country-link-lang {{ country.name }}
</template>

<script>
import { mapState } from 'vuex'

import { SEARCH_PARAMS } from '@/constants/searchParams'
import selfHostedSites from '@/constants/selfHostedSites'

export default {
  name: 'HeaderTopCountries',
  data: () => ({
    active: false
  }),
  computed: {
    ...mapState('siteVersions', {
      currentCountry: state => state.item,
      siteVersions: state => state.items,
      selfHosted: () => Object.entries(selfHostedSites).find(([_, host]) => window.location.href.startsWith(host))
    }),
    ...mapState('main', ['clientLocation', 'allowedLocales']),
    availableSiteVersions: vm => vm.siteVersions.filter(version => {
      if (version.code === 'ru' && !vm.$route.query[SEARCH_PARAMS.COUNTRY_FILTER]) return false

      const allowedList = vm.allowedLocales[version.code]
      const currentLocale = vm.currentLocale || vm.selfHosted?.[0]

      if (!allowedList) return true

      return allowedList.includes(currentLocale)
    }).sort(version => version.id === vm.currentCountry.id ? -1 : 1),
    currentLocale: vm => vm.$route.query[SEARCH_PARAMS.LOCALE]
  },
  methods: {
    changeCountry (code) {
      if (this.selfHosted) {
        this.redirectFromSelfHosted(code)
      } else {
        this.redirectFromGlobal(code)
      }
    },
    redirectFromSelfHosted (code) {
      if (code === this.selfHosted[0]) return

      const searchParams = new URLSearchParams(Object.entries({
        ...this.$route.query,
        [SEARCH_PARAMS.LOCALE]: code
      }))

      if (selfHostedSites[code]) {
        searchParams.delete(SEARCH_PARAMS.LOCALE)

        return window.location.replace(`${selfHostedSites[code]}?${searchParams.toString()}`)
      }

      return location.replace(`https://gorillaenergy.com?${searchParams.toString()}`)
    },
    redirectFromGlobal (code) {
      if (selfHostedSites[code]) {
        const searchParams = new URLSearchParams(Object.entries(this.$route.query))
        searchParams.delete(SEARCH_PARAMS.LOCALE)

        return window.location.replace(`${selfHostedSites[code]}?${searchParams.toString()}`)
      }

      if (this.currentLocale && this.currentLocale === code) return

      this.$router.replace({ query: { ...this.$route.query, [SEARCH_PARAMS.LOCALE]: code } })
      location.reload()
    },
    hide () {
      this.active = false
    },
    toggle () {
      this.active = !this.active
    }
  }
}
</script>
